import React from 'react'
import CX from 'classnames'

/**
 * 当组件容器需要添加额外classNames时处理的高阶函数
 * @param classNames
 * @returns {function(*): {new(props: Readonly<P>): WrapperComponent, new(props: P, context?: any): WrapperComponent, prototype: WrapperComponent}}
 */
export function handleClassNames (classNames) {
  return function (Component) {
    return class WrapperComponent extends React.PureComponent {
      render () {
        const {
          className,
          ...props
        } = this.props
        const classnames = CX(classNames, className)
        return <Component className={classnames} {...props} />
      }
    }
  }
}
